<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">検収日入力</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<!-- TODO value変更 -->
				<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
					<tbody>
						<ShowDetailRecord
							:columnName="'現在検収日'"
							:value="'2023/05/01'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord :columnName="'検収日'">
							<template v-slot:value>
								<v-menu
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="newAcceptanceInspectionDate"
											clearable
											outlined
											background-color="white"
											hide-details
											dense
											readonly
											v-bind="attrs"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="newAcceptanceInspectionDate"
										no-title
										scrollable
										locale="ja-JP"
									/>
								</v-menu>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
				<!-- TODO value変更 -->
				<h6 class="text-body-1 font-weight-bold mt-4">製品情報</h6>
				<table width="100%" class="mt-2 show-dialog-table">
					<tbody>
						<ShowDetailRecord :columnName="'製品名'" :value="'バルブボックスゴムライニング'" />
						<ShowDetailRecord :columnName="'品番'" :value="'LA079001'" />
						<ShowDetailRecord
							:columnName="'現在単価'"
							:value="Number(1500000).toLocaleString() + '円'"
						/>
						<ShowDetailRecord :columnName="'現在数量'" :value="3" />
					</tbody>
				</table>

				<h6 class="text-body-1 font-weight-bold mt-4">変更内容</h6>
				<!-- TODO -->
				<table width="100%" class="mt-2 show-dialog-table show-dialog-table--form">
					<tbody>
						<ShowDetailRecord :columnName="'単価'">
							<template v-slot:value>
								<v-text-field
									v-model="newUnitPrice"
									clearable
									outlined
									background-color="white"
									suffix="円"
									hide-details
									dense
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'数量'">
							<template v-slot:value>
								<v-text-field
									v-model="newQuantity"
									clearable
									outlined
									background-color="white"
									hide-details
									dense
								/>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>

				<v-row no-gutters class="mt-4" justify="center">
					<ConfirmationDialog :confirm_options="confirm_options" requireBtn @accept="updateMatter">
						<template v-slot:open-btn-content>
							<v-icon class="mr-1">mdi-content-save-outline</v-icon>
							保存する
						</template>
						<template v-slot:text>
							<p>変更しますが、本当によろしいですか</p>
						</template>
					</ConfirmationDialog>
				</v-row>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import ConfirmationDialog from "../../shared/ConfirmationDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		matter: {
			type: Object,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
		ConfirmationDialog,
	},
	data() {
		return {
			confirmationDialog: false,
			valid: false,
			common,
			rules,
			newAcceptanceInspectionDate: null,
			newUnitPrice: null,
			newQuantity: null,
			confirm_options: {
				title: "内容変更",
				accept_text: "変更する",
				cancel_text: "戻る",
			},
		}
	},
	methods: {
		updateMatter() {
			// TODO
			const headers = authenticate.setHeader()
			const url = ``
			const params = {}
			axios
				.put(url, params, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.confirmationDialog = false
					this.$emit("update-matter", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>